export const RECEIVE_V2_PRINT_SETTINGS = 'RECEIVE_V2_PRINT_SETTINGS';
export const RESTORE_PRINT_SETTINGS_SUCCESS = 'RESTORE_PRINT_SETTINGS_SUCCESS';

export const restorePrintSettingsSuccess = (printSettings) => {
  return {
    type: RESTORE_PRINT_SETTINGS_SUCCESS,
    printSettings,
  };
};

export const CLEAR_ALL_SETTINGS_WITH_WORKSTATION = 'CLEAR_ALL_SETTINGS_WITH_WORKSTATION';
export const clearPrintSettingsWithWorkstation = (workstationId) => ({
  type: CLEAR_ALL_SETTINGS_WITH_WORKSTATION,
  workstationId,
});

export const SAVE_PRINT_SETTINGS = 'SAVE_PRINT_SETTINGS';
export const savePrintSettings = (printSettingsKey, printer) => ({
  type: SAVE_PRINT_SETTINGS,
  printSettingsKey,
  printer,
});

export const SAVE_PRINT_WARNING_SETTINGS = 'SAVE_PRINT_WARNING_SETTINGS';
export const savePrintWarningSettings = (settingsKey, value) => ({
  type: SAVE_PRINT_WARNING_SETTINGS,
  settingsKey,
  value,
});
